import type { BattleView, CardDefinition } from '../../../engine/types';
import { RoleBasedBotPolicy } from '../../core/role-based-policy';
import type { BotPolicy, BotPolicyContext } from '../../core/types';

export const ADAPTIVE_BOT_ID = 'adaptive-counter';
export const ADAPTIVE_BOT_VERSION = '1.0.0';

function adaptiveScore(card: CardDefinition, context: BotPolicyContext, view: BattleView): number {
  const style = context.strategy.style;
  const confidence = context.strategy.confidence;
  if (confidence <= 0) return 0;
  let raw = 0;
  if (card.roles.includes('defense')) raw += style.aggression * 22 + style.beatdown * 28;
  if (card.roles.includes('anti-air')) raw += style.airPressure * 35;
  if (card.roles.includes('splash')) raw += style.swarm * 35 + style.cycle * 10;
  if (card.roles.includes('tank')) raw += style.defense * 18 + style.spellControl * 12;
  if (card.roles.includes('ranged')) raw += style.beatdown * 10;
  if (card.roles.includes('spell')) raw += style.swarm * 15 + style.defense * 8;
  const ownThreats = view.entities.filter((entity) => entity.owner !== context.playerId && entity.kind !== 'tower' && !entity.dead).length;
  if (ownThreats > 3 && (card.roles.includes('splash') || card.roles.includes('defense'))) raw += 12_000;
  return Math.round(raw * confidence / 1_000_000);
}

export function createAdaptiveBotPolicy(context: BotPolicyContext): BotPolicy {
  return new RoleBasedBotPolicy(ADAPTIVE_BOT_ID, ADAPTIVE_BOT_VERSION, context, (card, view) => adaptiveScore(card, context, view));
}
